// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"1a4fd9c0","453":"3a55459a"}[chunkId] + ".chunk.js";
};